import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class PageTitleStrategy extends TitleStrategy {
  private readonly title: Title = inject(Title);
  private readonly translate: TranslateService = inject(TranslateService);

  constructor() {
    super();
  }

  public override updateTitle(routerState: RouterStateSnapshot): void {
    const title = this.buildTitle(routerState);

    let pageTitle: string = this.translate.instant('COMMON.TITLE_PAGE');

    if (title !== undefined) {
      const titleTranslate = this.translate.instant(title);
      pageTitle = `${pageTitle} - ${titleTranslate}`;
    }

    this.title.setTitle(pageTitle);
  }
}
